import { render, staticRenderFns } from "./KategoriFoto.vue?vue&type=template&id=c8f7b1ae&"
import script from "./KategoriFoto.vue?vue&type=script&lang=js&"
export * from "./KategoriFoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports